import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const capMeta            = () => client.get('/capstone/meta').then((r) => r.data);
export const capListProjects    = () => client.get('/capstone/projects').then((r) => r.data);
export const capCreateProject   = (payload) => client.post('/capstone/projects', payload).then((r) => r.data);
export const capGetProject      = (id) => client.get(`/capstone/projects/${id}`).then((r) => r.data);
export const capUpdateProject   = (id, payload) => client.patch(`/capstone/projects/${id}`, payload).then((r) => r.data);

export const capListTasks       = (id) => client.get(`/capstone/projects/${id}/tasks`).then((r) => r.data);
export const capCreateTask      = (id, payload) => client.post(`/capstone/projects/${id}/tasks`, payload).then((r) => r.data);
export const capUpdateTask      = (taskId, payload) => client.patch(`/capstone/tasks/${taskId}`, payload).then((r) => r.data);
export const capDeleteTask      = (taskId) => client.delete(`/capstone/tasks/${taskId}`).then((r) => r.data);

export const capListDocs        = (id) => client.get(`/capstone/projects/${id}/documents`).then((r) => r.data);
export const capUploadDoc       = (id, file, docType, phaseId, onProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('doc_type', docType || 'Other');
  if (phaseId) fd.append('phase_id', phaseId);
  return client.post(`/capstone/projects/${id}/documents`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: onProgress,
  }).then((r) => r.data);
};
export const capDeleteDoc       = (docId) => client.delete(`/capstone/documents/${docId}`).then((r) => r.data);

export const capListReviews     = (id) => client.get(`/capstone/projects/${id}/reviews`).then((r) => r.data);
export const capRequestReview   = (id, phaseId) => client.post(`/capstone/projects/${id}/request-review`, { phase_id: phaseId }).then((r) => r.data);
export const capAddReview       = (id, payload) => client.post(`/capstone/projects/${id}/reviews`, payload).then((r) => r.data);
export const capRespondReview   = (reviewId, text) => client.post(`/capstone/reviews/${reviewId}/respond`, { text }).then((r) => r.data);
export const capMentorQueue     = () => client.get('/capstone/mentor/queue').then((r) => r.data);

export const capListRisks       = (id) => client.get(`/capstone/projects/${id}/risks`).then((r) => r.data);
export const capCreateRisk      = (id, payload) => client.post(`/capstone/projects/${id}/risks`, payload).then((r) => r.data);
export const capUpdateRisk      = (riskId, payload) => client.patch(`/capstone/risks/${riskId}`, payload).then((r) => r.data);
export const capDeleteRisk      = (riskId) => client.delete(`/capstone/risks/${riskId}`).then((r) => r.data);

export const capActivity        = (id) => client.get(`/capstone/projects/${id}/activity`).then((r) => r.data);
export const capNotifications   = () => client.get('/capstone/notifications').then((r) => r.data);
export const capMarkRead        = () => client.post('/capstone/notifications/read').then((r) => r.data);

export const capAdminOverview   = (params = {}) => client.get('/capstone/admin/overview', { params }).then((r) => r.data);

export const capGuide           = (projectId, topic, extra = '') => client.post(`/capstone/guide/${projectId}`, { topic, extra }).then((r) => r.data);
export const capGuideDraft      = (payload) => client.post('/capstone/guide/draft', payload).then((r) => r.data);
export const capRefine          = (fields, context = {}) => client.post('/capstone/guide/refine', { fields, context }).then((r) => r.data);

export const capGenerateDeck    = (id, payload) => client.post(`/capstone/projects/${id}/deck`, payload).then((r) => r.data);
export const capListDecks       = (id) => client.get(`/capstone/projects/${id}/decks`).then((r) => r.data);

export const capDownload = async (path, fallbackName) => {
  const resp = await fetch(`${API}${path}`, { credentials: 'include' });
  if (!resp.ok) throw new Error(`Download failed (HTTP ${resp.status})`);
  const blob = await resp.blob();
  let filename = fallbackName;
  const m = (resp.headers.get('content-disposition') || '').match(/filename="([^"]+)"/);
  if (m) filename = m[1];
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1500);
};
